// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.table-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 0 var(--content-margin);
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.table-container::-webkit-scrollbar {
  width: 8px;
}
.table-container::-webkit-scrollbar-track {
  background: transparent;
}
.table-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}

table {
  width: 100%;
}

.compact {
  height: 38px !important;
}

.compact td,
.compact th {
  font-size: 9pt;
}

tr.mat-mdc-row:hover {
  background-color: var(--preset-hover);
}

.labelled-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.editable-cell {
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
}
.editable-cell:hover:not(.disabled) {
  background-color: rgba(255, 255, 255, 0.1);
}
.editable-cell.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.inline-edit {
  background: transparent;
  border: 1px solid var(--primary-color, #4fc3f7);
  border-radius: 3px;
  color: inherit;
  font: inherit;
  padding: 2px 4px;
  width: 50%;
  box-sizing: border-box;
}
.inline-edit:focus {
  outline: none;
  border-color: var(--primary-color, #4fc3f7);
  box-shadow: 0 0 0 1px var(--primary-color, #4fc3f7);
}

.card-container {
  margin: 0 var(--content-margin);
  padding-bottom: 0.5rem;
}
.card-container .card {
  flex: 1;
  max-width: 360px;
}
.card-container .card .card-title {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}
.card-container .card .card-footer {
  text-align: center;
  margin: 0;
}

.vaulted-models-card {
  text-align: center;
  font-size: 4rem;
  font-weight: bold;
  margin: 0;
}

.donut-legend-card {
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}
.donut-legend-card .left {
  width: 82px;
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.donut-legend-card .left .stacked-spinner {
  position: absolute;
}
.donut-legend-card .right {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  opacity: 0.6;
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.empty-state h3 {
  margin: 0;
}
.empty-state p {
  margin: 0;
  font-size: 0.9em;
}

.column-search {
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid rgba(128, 128, 128, 0.3);
  outline: none;
  font-size: 14px;
  background: transparent;
  color: inherit;
  box-sizing: border-box;
}

::ng-deep .hidden-option {
  display: none !important;
}

.clickable {
  cursor: pointer;
  border-radius: 50%;
  padding: 2px;
}
.clickable:hover {
  background-color: var(--preset-hover);
}

.notes-button.mat-mdc-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.notes-button.mat-mdc-icon-button .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.5;
}
.notes-button.mat-mdc-icon-button .mat-icon.has-notes {
  opacity: 1;
  color: var(--primary-color, #4fc3f7);
}

::ng-deep .notes-tooltip {
  max-width: 400px;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/vault/vault.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,qDAAA;AACF;AACE;EACE,UAAA;AACJ;AACE;EACE,uBAAA;AACJ;AACE;EACE,oCAAA;EACA,kBAAA;AACJ;AACI;EACE,oCAAA;AACN;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;;EAEE,cAAA;AADF;;AAKE;EACE,qCAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAHF;AAKE;EACE,0CAAA;AAHJ;AAME;EACE,mBAAA;EACA,YAAA;AAJJ;;AAQA;EACE,uBAAA;EACA,+CAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;AALF;AAOE;EACE,aAAA;EACA,2CAAA;EACA,mDAAA;AALJ;;AASA;EACE,+BAAA;EACA,sBAAA;AANF;AAQE;EAYE,OAAA;EACA,gBAAA;AAjBJ;AAKI;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AAHN;AAMI;EACE,kBAAA;EACA,SAAA;AAJN;;AAYA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AATF;AAWE;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;AAYI;EACE,kBAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAbF;AAeE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAbJ;AAgBE;EACE,SAAA;AAdJ;AAiBE;EACE,SAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,wBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AAhBF;AAkBE;EACE,qCAAA;AAhBJ;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;AAmBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAjBJ;AAmBI;EACE,UAAA;EACA,oCAAA;AAjBN;;AAuBA;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AApBF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.table-container {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  margin: 0 var(--content-margin);\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n}\n\ntable {\n  width: 100%;\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.compact td,\n.compact th {\n  font-size: 9pt;\n}\n\ntr.mat-mdc-row {\n  &:hover {\n    background-color: var(--preset-hover);\n  }\n}\n\n.labelled-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.editable-cell {\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 3px;\n\n  &:hover:not(.disabled) {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n}\n\n.inline-edit {\n  background: transparent;\n  border: 1px solid var(--primary-color, #4fc3f7);\n  border-radius: 3px;\n  color: inherit;\n  font: inherit;\n  padding: 2px 4px;\n  width: 50%;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n    border-color: var(--primary-color, #4fc3f7);\n    box-shadow: 0 0 0 1px var(--primary-color, #4fc3f7);\n  }\n}\n\n.card-container {\n  margin: 0 var(--content-margin);\n  padding-bottom: 0.5rem;\n\n  .card {\n    .card-title {\n      text-align: center;\n      font-weight: bold;\n      font-size: 14px;\n    }\n\n    .card-footer {\n      text-align: center;\n      margin: 0;\n    }\n\n    flex: 1;\n    max-width: 360px;\n  }\n}\n\n.vaulted-models-card {\n  text-align: center;\n  font-size: 4rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n.donut-legend-card {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  justify-content: center;\n\n  .left {\n    width: 82px;\n    height: 82px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .stacked-spinner {\n      position: absolute;\n    }\n  }\n\n  .right {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n.empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  opacity: 0.6;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  h3 {\n    margin: 0;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9em;\n  }\n}\n\n.column-search {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.3);\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n  color: inherit;\n  box-sizing: border-box;\n}\n\n::ng-deep .hidden-option {\n  display: none !important;\n}\n\n.clickable {\n  cursor: pointer;\n  border-radius: 50%;\n  padding: 2px;\n\n  &:hover {\n    background-color: var(--preset-hover);\n  }\n}\n\n.notes-button.mat-mdc-icon-button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    opacity: 0.5;\n\n    &.has-notes {\n      opacity: 1;\n      color: var(--primary-color, #4fc3f7);\n    }\n  }\n}\n\n// Global tooltip style for notes - needs ::ng-deep since tooltip is in overlay\n::ng-deep .notes-tooltip {\n  max-width: 400px;\n  white-space: pre-wrap;\n  font-family: monospace;\n  font-size: 12px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
